import { IsOptional, IsString, IsInt } from 'class-validator';

export class AisAgreementRequestDto {
  @IsInt()
  businessEntityId: number;

  @IsString()
  @IsOptional()
  providerCode?: string;

  @IsString()
  institutionCode: string;

  @IsInt()
  maxHistoricalDays: number;

  @IsInt()
  accessValidForDays: number;

  @IsString()
  ipAddress: string;

  @IsString()
  userAgent: string;
}
